/**
 * SubpageHero — единен, спокоен академичен хедър за публичните подстраници
 * (/about, /platform, /faq, /guide, /legal, /refund, /technical).
 */
import React from "react";
import { useTheme } from "@/theme/ThemeContext";

export default function SubpageHero({
  eyebrow,
  title,
  subtitle,
  meta,
  icon: Icon,
  accent = "#0e5c60",
  testId = "subpage-hero",
}) {
  const { isDark } = useTheme();
  return (
    <header className="relative" data-testid={testId}>
      <div
        className="absolute inset-x-0 top-0 h-px opacity-60"
        style={{ background: `linear-gradient(90deg, transparent, ${accent}, transparent)` }}
        aria-hidden="true"
      />
      <div className="pt-10 sm:pt-14 pb-8 sm:pb-12">
        <div className="flex items-center gap-3 mb-5">
          {Icon && (
            <span
              className="inline-flex items-center justify-center w-9 h-9 rounded-xl shrink-0"
              style={{ background: `${accent}1A`, color: accent }}
            >
              <Icon className="w-4.5 h-4.5" style={{ width: 18, height: 18 }} />
            </span>
          )}
          {eyebrow && (
            <span
              className="text-[11px] font-semibold uppercase tracking-[0.24em]"
              style={{ color: accent }}
              data-testid={`${testId}-eyebrow`}
            >
              {eyebrow}
            </span>
          )}
        </div>
        <h1
          className={`text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] ${
            isDark ? "text-white" : "text-[#101828]"
          }`}
          style={{ fontFamily: "'Work Sans', 'IBM Plex Sans', sans-serif" }}
          data-testid={`${testId}-title`}
        >
          {title}
        </h1>
        {subtitle && (
          <p
            className={`mt-5 text-base sm:text-lg leading-relaxed max-w-2xl ${
              isDark ? "text-slate-400" : "text-slate-600"
            }`}
            data-testid={`${testId}-subtitle`}
          >
            {subtitle}
          </p>
        )}
        {meta && (
          <div className={`mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs ${isDark ? "text-slate-500" : "text-slate-400"}`}>
            {meta.map((m) => (
              <span key={m} className="inline-flex items-center gap-2">
                <span className="w-1 h-1 rounded-full" style={{ background: accent }} aria-hidden="true" />
                {m}
              </span>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
